import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import AuthenticatedApp from './components/AuthenticatedApp';
import './index.css';

// Crear la instancia de MSAL
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  // El contenedor `.app` (con su padding y el hueco del header fijo) lo pone
  // AuthenticatedApp, que es quien sabe si se está mostrando v1 o v2. Aquí
  // envolvía a todo, y por eso la v2 —que ocupa la pantalla entera— aparecía
  // enmarcada en un margen blanco.
  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedApp />
    </MsalProvider>
  );
}

export default App;